import { Grid, Tab } from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { getDepartmentsUser, isAdmin } from "app/common/LocalFunction";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import { memo, useEffect, useState } from "react";
import ServiceFeePopup from "./Popup/ServiceFeePopup";
import HistoryChangeRemainTabIndex from "./Tabs/HistoryChangeRemainTab/HistoryChangeRemainTabIndex";
import HistoryDepositIndex from "./Tabs/HistoryDepositTab/HistoryDepositIndex";
import ServiceFeeTab from "./Tabs/ServiceFeeTab/ServiceFeeTabIndex";

const TAB_LIST = [
  {
    tabName: "Danh sách phiếu",
    content: (
      <>
        <ServiceFeeTab />
      </>
    ),
    value: 0,
  },
  {
    tabName: "Lịch sử tiền cọc",
    content: (
      <>
        <HistoryDepositIndex />
      </>
    ),
    value: 1,
  },
  {
    tabName: "Lịch sử chuyển đổi số dư",
    content: (
      <>
        <HistoryChangeRemainTabIndex />
      </>
    ),
    value: 2,
  },
];
const FeeIndex = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const {
    handleCloseServiceFeePopup,
    openInvoicePopup,
    dataInvoicePopupFee,
    getListPaymentMethod,
    resetStore,
  } = useStore().feeStore.serviceFeeTabStore;
  const { handleGetPatientOverviewByIdNotLoading } =
    useStore().patientManagementStore.patientGeneralStore;

  const departmentsUser = getDepartmentsUser();
  let isAdminPermission = isAdmin();

  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  useEffect(() => {
    if (patientId) {
      getListPaymentMethod();
    }
    return () => resetStore();
  }, []);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <TabContext value={currentTab}>
          <TabList
            className="tabs-container-white tab-custom-fee"
            // variant="scrollable"
            // scrollButtons="on"
            onChange={(_, newTabIndex) => {
              setCurrentTab(newTabIndex);
            }}
            value={currentTab}
          >
            {TAB_LIST.map((tab, index) => (
              <Tab
                key={index}
                className={`item-tabs  ${
                  index === currentTab ? "item-tabs-active" : ""
                }`}
                label={tab.tabName}
                value={index}
              />
            ))}
          </TabList>
          {TAB_LIST.map((tab, index) => (
            <TabPanel
              component="section"
              className="p-0"
              key={tab.value}
              value={index}
            >
              {tab.content}
            </TabPanel>
          ))}
        </TabContext>

        {openInvoicePopup && (
          <ServiceFeePopup
            open={openInvoicePopup}
            handleClose={handleCloseServiceFeePopup}
            data={dataInvoicePopupFee}
            handleAfterSubmit={() => {
              handleGetPatientOverviewByIdNotLoading(patientId);
            }}
            isAdminPermission={isAdminPermission}
            departmentsUser={departmentsUser}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default memo(observer(FeeIndex));
